import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function FreeCardSection() {
  const [isRevealed, setIsRevealed] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const handleScrollToBonuses = () => {
    const bonosSection = document.getElementById('bonos');
    if (bonosSection) {
      bonosSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <section className="py-24 px-4 bg-[#0C0F17] overflow-hidden relative" data-id="element-51">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 opacity-20" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/uJDTEPn8MoLuEohKSP7QKB/c09bfdba-788e-4ee0-b63e-82334b2f5e1a.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} data-id="element-52" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0C0F17] via-[#0C0F17]/95 to-[#0C0F17]" data-id="element-53" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-54">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} className="mb-12" data-id="element-55">
          <h2 className="text-4xl md:text-5xl font-serif text-[#F7F5F2] mb-4" data-id="element-56">
            Da el primer paso: revela una carta gratuita
          </h2>
          <p className="text-lg text-[#F7F5F2]/70" data-id="element-57">
            Haz clic para recibir un mensaje para tu energía actual.
          </p>
        </motion.div>

        <div className="flex flex-col items-center" data-id="element-58">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: 0.2,
          ease: [0.22, 1, 0.36, 1]
        }} className="relative w-64 h-96 cursor-pointer mb-8" onClick={() => setIsRevealed(!isRevealed)} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} data-id="element-59">
            {!isRevealed ?
          // Card Back (Mystical Pattern)
          <motion.div initial={{
            opacity: 1
          }} animate={{
            opacity: 1
          }} exit={{
            opacity: 0
          }} className="w-full h-full bg-[#0A0D14] rounded-[18px] flex items-center justify-center overflow-hidden relative" style={{
            border: '1px solid rgba(207, 168, 106, 0.35)',
            boxShadow: isHovered ? '0 0 35px rgba(207, 168, 106, 0.5)' : '0 0 30px rgba(207, 168, 106, 0.35)',
            transform: isHovered ? 'translateY(-4px) scale(1.01)' : 'translateY(0) scale(1)',
            transition: 'all 0.4s cubic-bezier(0.22, 1, 0.36, 1)'
          }} data-id="element-60">
                <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')]" data-id="element-61" />
                <motion.div animate={{
              opacity: [0.4, 0.7, 0.4]
            }} transition={{
              duration: 4,
              repeat: Infinity,
              ease: 'easeInOut'
            }} data-id="element-62">
                  <Sparkles className="w-12 h-12 text-[#CFA86A] relative z-10" data-id="element-63" />
                </motion.div>

                {/* "CLICK AQUÍ" text */}
                <AnimatePresence data-id="element-64">
                  {!isRevealed && <motion.div initial={{
                opacity: 0
              }} animate={{
                opacity: 1
              }} exit={{
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-65">
                      <motion.span animate={{
                  opacity: [0.3, 0.6, 0.3]
                }} transition={{
                  duration: 2,
                  repeat: Infinity,
                  ease: 'easeInOut'
                }} className="text-white/30 text-2xl font-bold tracking-widest" style={{
                  textShadow: '0 0 20px rgba(255, 255, 255, 0.3)'
                }} data-id="element-66">
                        CLICK AQUÍ
                      </motion.span>
                    </motion.div>}
                </AnimatePresence>
              </motion.div> :
          // Card Front (Message)
          <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} exit={{
            opacity: 0
          }} transition={{
            duration: 0.4
          }} className="w-full h-full bg-[#0A0D14] rounded-[18px] flex flex-col items-center justify-center p-6 text-center" style={{
            border: '1px solid rgba(207, 168, 106, 0.35)',
            boxShadow: isHovered ? '0 0 40px rgba(207, 168, 106, 0.6)' : '0 0 35px rgba(207, 168, 106, 0.5)',
            transform: isHovered ? 'translateY(-4px) scale(1.01)' : 'translateY(0) scale(1)',
            transition: 'all 0.4s cubic-bezier(0.22, 1, 0.36, 1)'
          }} data-id="element-67">
                <span className="text-[#CFA86A] font-serif text-sm uppercase tracking-widest mb-4" data-id="element-68">
                  Tu Mensaje
                </span>
                <h3 className="text-2xl font-serif text-[#F7F5F2] mb-4" data-id="element-69">
                  Confianza interior
                </h3>
                <p className="text-[#F7F5F2]/80 text-sm leading-relaxed mb-6" data-id="element-70">
                  Esta carta es poderosa: eso que tanto deseas está más cerca de
                  lo que imaginas… pero ten cuidado.
                </p>
                <p className="text-xs italic text-[#F7F5F2]/60 leading-relaxed mt-4" data-id="element-71">
                  "La respuesta que buscas ya vive en ti. Silencia el ruido
                  externo y escucha tu primera intuición."
                </p>
              </motion.div>}
          </motion.div>

          {/* Button to scroll to bonuses */}
          <motion.button initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: 0.4,
          ease: [0.22, 1, 0.36, 1]
        }} onClick={handleScrollToBonuses} className="px-8 py-3 rounded-lg bg-[#CFA86A] text-[#0C0A09] font-semibold tracking-wide transition-all duration-300 hover:brightness-110" style={{
          boxShadow: '0 0 20px rgba(207, 168, 106, 0.3)'
        }} data-id="element-72">
            Más información sobre tu carta aquí
          </motion.button>
        </div>
      </div>
    </section>;
}